<template>
  <router-view/>
</template>

<style>
  @font-face {
    font-family: 'IRANSansWeb(FaNum)';
    src: url(./assets/fonts/IRANSansWebFaNum.ttf) format('truetype');
  }

  body {
    font-family: 'IRANSansWeb(FaNum)', sans-serif !important;
    direction: rtl;
  }
  #app {
    font-family: 'IRANSansWeb(FaNum)', sans-serif !important;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }

  nav {
    padding: 30px;
  }

  nav a {
    font-weight: bold;
    color: #2c3e50;
  }

  nav a.router-link-exact-active {
    color: #42b983;
  }
  @import 'bootstrap/dist/css/bootstrap.min.css';
</style>

<script>
import axios from 'axios';
import { provide, ref } from 'vue';
import { useRouter } from 'vue-router';
import "animate.css";

export default {
  name: 'App',
  setup() {
    const user = ref(null);
    const router = useRouter();

    // Provide the user data
    provide('user', user);

    // Load user data asynchronously
    const loadUser = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          // window.location.href = '/login'; // یا استفاده از router.push
          return;
        }
        const response = await axios.post(
          'https://api.noticapp.ir/v1/auth/me',
          {},
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        user.value = response.data;

      } catch (error) {
        if (error.response && error.response.status === 401) {
          localStorage.removeItem('token');
          router.push('/login');
        } else {
          console.error('خطای ناشناخته رخ داده است: ', error.response);
        }
      }
    };

    loadUser();

    return {};
  },
};
</script>

